import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { SwPartNumber } from '../../shared/models/sw-part-number/sw-part-number';
import { STORAGE_KEYS } from '../../shared/constants/storage-keys';
import { SwPartNumberApiService } from './api/sw-part-number-api.service';

@Injectable({
  providedIn: 'root',
})
export class SwPartNumberService {
  public swPartNumberChangeSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(
    this.getSwPartNumber()?.id ?? null
  );

  private readonly swPartNumberApi = inject(SwPartNumberApiService);
  private swPartNumber: SwPartNumber | null = null;

  public setSwPartNumber(swPartNumber: SwPartNumber): void {
    if (this.swPartNumber?.id === swPartNumber.id) return;

    this.swPartNumber = swPartNumber;
    const swPartNumberString = JSON.stringify(swPartNumber);
    localStorage.setItem(STORAGE_KEYS.SW_PART_NUMBER, swPartNumberString);
    this.swPartNumberChangeSubject.next(swPartNumber.id ?? null);
  }

  public getSwPartNumber(): SwPartNumber | null {
    if (this.swPartNumber) {
      return this.swPartNumber;
    } else {
      const swPartNumberString = localStorage.getItem(STORAGE_KEYS.SW_PART_NUMBER);

      if (swPartNumberString) {
        this.swPartNumber = JSON.parse(swPartNumberString) as SwPartNumber;
        return this.swPartNumber;
      } else {
        return null;
      }
    }
  }

  public getSwPartNumberId(): string | null {
    return this.getSwPartNumber()?.id ?? null;
  }

  public async initSwPartNumbers(): Promise<void> {
    if (!this.getSwPartNumber()) {
      const swPartNumbers = await firstValueFrom(this.swPartNumberApi.getSwPartNumbers());
      if (swPartNumbers.length > 0) {
        this.setSwPartNumber(swPartNumbers[0]);
      }
    }
  }
}
